<template>
  <div class="content-page">
    <div class="tab-header">
      <el-button type="primary" size="medium" @click="addMatrixCodeGroup"
        >新增分组</el-button
      >
    </div>
    <div class="tab-content">
      <el-table :data="matrixCodeList" height="618">
        <el-table-column align="left" prop="groupName" label="分组名称"></el-table-column>
        <el-table-column align="center" label="操作" width="300">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="lookDetail(scope.row)"
              >编辑</el-button
            >
            <el-button type="primary" size="small" @click="staffGroup(scope.row)"
              >授权</el-button
            >
            <el-button type="primary" size="small" @click="viewTeamMembers(scope.row)"
              >组员</el-button
            >
            <el-button type="danger" size="small" @click="delMatrixCodeGroup(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-show="matrixCodeList.length > 0" style="padding-left: 15px">
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="pageSize"
        :current-page="pageNo"
        background
        layout="total, prev, pager, next"
        :total="pageCount"
      ></el-pagination>
    </div>
    <div
      class="popup group-edit"
      :class="{
        show: isShowMartixCodeGroupEditPopup,
      }"
    >
      <div class="popup-content">
        <div class="popup-header">
          <span>{{ groupId ? "编辑分组" : "创建分组" }}</span>
          <img
            class="close"
            src="../assets/img/icon-close-dark.png"
            alt=""
            @click="isShowMartixCodeGroupEditPopup = false"
          />
        </div>
        <div class="popup-container">
          <div class="form-item">
            <div class="form-title">分组名称</div>
            <div class="form-content">
              <el-input
                type="text"
                placeholder="请输入分组名称"
                v-model="groupName"
              ></el-input>
            </div>
          </div>
          <!-- <div class="form-item code" v-show="groupId">
            <div class="form-title">授权码</div>
            <div class="form-content">
              <div class="scan-code">
                <qrcode
                  :value="dyJsBdmStaffGroupUrl"
                  :options="{ size: 150 }"
                  class="scan-code-img"
                ></qrcode>
                <div>抖音授权进组码</div>
              </div>
              <div class="scan-code">
                <qrcode
                  :value="ksBdmStaffGroupUrl"
                  :options="{ size: 150 }"
                  class="scan-code-img"
                ></qrcode>
                <div>快手授权进组码</div>
              </div>
            </div>
          </div> -->
          <el-button type="primary" @click="updateGroup">确定</el-button>
        </div>
      </div>
    </div>
    <div
      class="popup staff-group"
      :class="{
        show: isShowMartixCodeStaffGroupPopup,
      }"
    >
      <div class="popup-content">
        <div class="popup-header">
          <span>授权码</span>
          <img
            class="close"
            src="../assets/img/icon-close-dark.png"
            alt=""
            @click="isShowMartixCodeStaffGroupPopup = false"
          />
        </div>
        <div class="popup-container">
          <el-radio-group size="small" v-model="tabPosition" style="margin-bottom: 20px">
            <el-radio-button label="douyin">抖音进组码</el-radio-button>
            <el-radio-button label="kuaishou">快手进组码</el-radio-button>
          </el-radio-group>
          <div class="form-item code">
            <div class="form-content">
              <div class="scan-code" v-show="tabPosition == 'douyin'">
                <qrcode
                  :value="dyJsBdmStaffGroupUrl"
                  :options="{ size: 150 }"
                  class="scan-code-img"
                ></qrcode>
                <div>抖音授权进组码</div>
              </div>
              <div class="scan-code" v-show="tabPosition == 'kuaishou'">
                <qrcode
                  :value="ksBdmStaffGroupUrl"
                  :options="{ size: 150 }"
                  class="scan-code-img"
                ></qrcode>
                <div>快手授权进组码</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="popup group-member"
      :class="{
        show: isShowMartixCodeGroupMemberPopup,
      }"
    >
      <div class="popup-content">
        <div class="popup-header">
          <span>组员</span>
          <img
            class="close"
            src="../assets/img/icon-close-dark.png"
            alt=""
            @click="isShowMartixCodeGroupMemberPopup = false"
          />
        </div>
        <div class="popup-container">
          <el-table :data="groupMemberList">
            <el-table-column label="头像" align="center">
              <template slot-scope="scope">
                <img class="avatar-img" :src="scope.row.authorizerHeadImage" />
              </template>
            </el-table-column>
            <el-table-column prop="authorizerNickName" label="组员名称" align="center">
            </el-table-column>
            <el-table-column label="所属平台" align="center">
              <template slot-scope="scope">{{
                scope.row.thirdPartyPlatform == 101 ? "抖音" : "快手"
              }}</template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="danger" size="small" @click="delGroupMember(scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change="handleGroupMemberCurrentChange"
            :page-size="groupMemberPageSize"
            :current-page="groupMemberPageNo"
            background
            layout="prev, pager, next, jumper"
            :total="groupMemberTotalPage"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getMatrixCodeGroupList,
  delMatrixCodeGroup,
  delGroupMember,
  updateGroup,
  getGroupInfo,
  getGroupMemberInfo,
  findUserFuncInfo,
} from "../api/index";
import qrcode from "@xkeshi/vue-qrcode";
export default {
  data() {
    return {
      pageNo: 1,
      pageSize: 10,
      pageCount: 0,
      matrixCodeList: [],
      isShowMartixCodeGroupEditPopup: false,
      isShowMartixCodeStaffGroupPopup: false,
      tabPosition: "douyin",
      dyJsBdmStaffGroupUrl: "",
      groupId: "",
      groupName: "",
      ksBdmStaffGroupUrl: "",
      groupMemberList: [],
      groupMemberPageNo: 1,
      groupMemberPageSize: 5,
      groupMemberTotalPage: 0,
      isShowMartixCodeGroupMemberPopup: false,
    };
  },
  components: {
    qrcode,
  },
  mounted() {
    findUserFuncInfo({
      userFuncType: 18,
    }).then((res) => {
      if (res.code == 1) {
        if (!(res.data.userFuncStatus == 20 || res.data.userFuncStatus == 30)) {
          window.history.back();
        } else {
          this.getMatrixCodeGroupList();
        }
      }
    });
  },
  watch: {
    isShowMartixCodeGroupEditPopup(val) {
      if (!val) {
        this.dyJsBdmStaffGroupUrl = "";
        this.groupId = "";
        this.groupName = "";
        this.ksBdmStaffGroupUrl = "";
      }
    },
    isShowMartixCodeStaffGroupPopup(val) {
      if (!val) {
        this.dyJsBdmStaffGroupUrl = "";
        this.groupId = "";
        this.groupName = "";
        this.ksBdmStaffGroupUrl = "";
      }
    },
  },
  methods: {
    getMatrixCodeGroupList() {
      getMatrixCodeGroupList({
        pageNumber: this.pageNo,
        pageSize: this.pageSize,
      }).then((res) => {
        if (res.code == 1) {
          this.matrixCodeList = res.data.list;
          this.pageCount = res.data.totalCount;
        } else {
          this.matrixCodeList = [];
        }
      });
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getMatrixCodeGroupList();
    },
    handleGroupMemberCurrentChange(val) {
      this.groupMemberPageNo = val;
      this.getGroupMemberInfo();
    },
    getGroupMemberInfo() {
      getGroupMemberInfo({
        groupId: this.groupId,
        pageNumber: this.groupMemberPageNo,
        pageSize: this.groupMemberPageSize,
      }).then((res) => {
        if (res.code == 1) {
          this.groupMemberList = res.data.list;
          this.groupMemberTotalPage = res.data.totalCount;
        } else {
          this.groupMemberList = [];
        }
      });
    },
    addMatrixCodeGroup() {
      this.isShowMartixCodeGroupEditPopup = true;
    },
    lookDetail(row) {
      getGroupInfo({
        groupId: row.groupId,
        isNeedQrCode: 0,
      }).then((res) => {
        if (res.code == 1) {
          this.groupId = res.data.groupId;
          this.groupName = res.data.groupName;
          this.isShowMartixCodeGroupEditPopup = true;
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 3000,
          });
        }
      });
    },
    staffGroup(row) {
      getGroupInfo({
        groupId: row.groupId,
        isNeedQrCode: 1,
      }).then((res) => {
        if (res.code == 1) {
          this.dyJsBdmStaffGroupUrl = res.data.dyJsBdmStaffGroupUrl;
          this.ksBdmStaffGroupUrl = res.data.ksBdmStaffGroupUrl;
          this.isShowMartixCodeStaffGroupPopup = true;
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 3000,
          });
        }
      });
    },
    updateGroup() {
      if (!this.groupName) {
        return this.$notify({
          title: "提示",
          message: "分组名称不能为空",
          type: "error",
          duration: 3000,
        });
      }
      let params = {
        groupName: this.groupName,
      };
      if (this.groupId) {
        params.groupId = this.groupId;
      }
      updateGroup(params).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: this.groupId ? "修改成功" : "创建成功",
            type: "success",
            duration: 1000,
          });
          this.isShowMartixCodeGroupEditPopup = false;
          this.getMatrixCodeGroupList();
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 3000,
          });
        }
      });
    },
    viewTeamMembers(row) {
      this.groupId = row.groupId;
      this.getGroupMemberInfo();
      this.isShowMartixCodeGroupMemberPopup = true;
    },
    delMatrixCodeGroup(row) {
      this.$confirm("此操作将永久删除该分组, 是否继续", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(({ value }) => {
        delMatrixCodeGroup({
          groupId: row.groupId,
        }).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "删除成功",
              type: "success",
              duration: 1000,
            });
            this.getMatrixCodeGroupList();
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 3000,
            });
          }
        });
      });
    },
    delGroupMember(row) {
      this.$confirm("此操作将永久删除该组员, 是否继续", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(({ value }) => {
        delGroupMember({
          groupId: this.groupId,
          bdmItemId: row.bdmItemId,
        }).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "删除成功",
              type: "success",
              duration: 1000,
            });
            this.getGroupMemberInfo();
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 3000,
            });
          }
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .tab-header {
  }
  .tab-content {
    // width: calc(100vw - 280px);
    padding: 0 15px;
  }
  .popup {
    .popup-container {
      padding: 20px;
    }
    &.group-member {
      z-index: 999;
      .popup-content {
        width: 800px;
        .avatar-img {
          width: 50px;
          height: 50px;
          border-radius: 50%;
        }
      }
    }
    &.group-edit {
      .popup-content {
        width: 400px;
        .popup-container {
          text-align: center;
          .el-button {
            margin-top: 20px;
          }
          .form-item {
            width: 100%;
            display: flex;
            align-items: center;
            &.code {
              flex-wrap: wrap;
              .form-content {
                min-width: 100%;
                display: flex;
                justify-content: center;

                .scan-code {
                  text-align: center;
                  color: rgba(143, 140, 140, 1);
                  font-size: 16px;
                }
                .scan-code-img {
                  width: 150px;
                  height: 150px;
                }
              }
            }
            .form-title {
              width: 80px;
              text-align: right;
              margin-right: 10px;
              line-height: 40px;
              font-size: 14px;
            }
            .form-content {
              flex: 1;
            }
          }
        }
      }
    }
    &.staff-group {
      .form-item {
        &.code {
          flex-wrap: wrap;
          .form-content {
            min-width: 100%;
            display: flex;
            justify-content: center;

            .scan-code {
              text-align: center;
              color: rgba(143, 140, 140, 1);
              font-size: 16px;
            }
            .scan-code-img {
              width: 150px;
              height: 150px;
            }
          }
        }
      }
    }
  }
}
</style>
